import React from "react";
import styles from "./Banner.module.css";

const CategoryBanner = (props) => {
  const { BannerData } = props;
  return (
    <div className="container">
      <div id={"view_first"} className={`${styles.banner}`}>
        <div className={`${styles.bannerSection}`}>
          <img
            className="img-fluid"
            src={
              window.innerWidth < 500
                ? BannerData?.category_image_mobile
                : BannerData?.category_icon
            }
            alt="Banner"
          />
        </div>
      </div>
    </div>
  );
};

export default CategoryBanner;
